import React from 'react'
import { Icon, ToolTip } from '@driftt/tide-core-legacy'
import {
    APP_URL
  } from 'constants/ResourcesConstants'
import * as TrackingActions from 'app/modules/tracking/actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
      {
        track: TrackingActions.track,
      },
      dispatch,
    ),
  })

const settingsClick = () => {
  track(`Navigation Item Clicked`, { subject: 'settings' })
}


const SettingsIcon = () => {

  return (
    <div className="nav-help-wrapper" data-ocweb-id="traffic-control.SettingsCog">
      <a href={`${APP_URL}/settings2/team`}>
        <div className="nav-help-tooltip" onClick={settingsClick}>
          <ToolTip className="navigation-hover-tooltip--wrapper" component={'Settings'}
            flow="right" tethered>
            <div className="nav-status-icon-wrapper">
              <Icon width={19} height={24}
                name="settings-1" />
            </div>
          </ToolTip>
        </div>
      </a>
    </div>
  )
}

export default connect(mapDispatchToProps)(SettingsIcon)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/Settings/index.js